import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { withTranslation } from "react-i18next";
function Comment({ item, t }) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {t('Comment')} ({typeof item?.payload?.comment === 'object' ? item?.payload?.comment.old : item?.payload?.comment}){" "}
        </strong> {item.payload.ticket && (<>{t('was associated with the ticket')} <strong>({item.payload?.ticket?.name}) </strong></>)}
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        by
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
          {item?.payload?.comment && typeof item?.payload?.comment === 'object' &&
            item?.payload?.comment?.old &&
            item?.payload?.comment?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Comment')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.comment?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.comment?.new}</span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Comment);